export enum MercadoPagoCardError {
  INVALID_EMAIL_FORMAT = 106,
  INVALID_FIRST_NAME = 107,
  INVALID_LAST_NAME = 108,
  INVALID_PHONE_AREA_CODE = 109,
  INVALID_PHONE_NUMBER = 110,
  INVALID_DOCUMENT_TYPE = 111,
  INVALID_DOCUMENT_NUMBER = 112,
  INVALID_POSTAL_CODE = 113,
  INVALID_STREET_NAME = 114,
  INVALID_REGISTRATION_DATE_FORMAT = 115,
  INVALID_DESCRIPTION = 116,
  CARD_REQUIRED = 119,
  INVALID_CARD = 121,
  INVALID_CARD_DATA = 122,
  PAYMENT_METHOD_REQUIRED = 123,
  ISSUER_ID_REQUIRED = 124,
  INVALID_REQUEST_PARAMETERS = 125,
  CANNOT_UPDATE_CUSTOMER_EMAIL = 126,
  MAX_SAVED_CARDS_LIMIT_REACHED = 129,
  INVALID_CARD_HOLDER = 140,
}

export const MercadoPagoCardErrorMessages: Record<number, string> = {
  [MercadoPagoCardError.INVALID_EMAIL_FORMAT]:
    'El formato de email no es válido.',
  [MercadoPagoCardError.INVALID_FIRST_NAME]: 'El nombre no es válido.',
  [MercadoPagoCardError.INVALID_LAST_NAME]: 'El apellido no es válido.',
  [MercadoPagoCardError.INVALID_PHONE_AREA_CODE]:
    'El código de área telefónico no es válido.',
  [MercadoPagoCardError.INVALID_PHONE_NUMBER]:
    'El número de teléfono no es válido.',
  [MercadoPagoCardError.INVALID_DOCUMENT_TYPE]:
    'El tipo de documento no es válido.',
  [MercadoPagoCardError.INVALID_DOCUMENT_NUMBER]:
    'El número de documento no es válido.',
  [MercadoPagoCardError.INVALID_POSTAL_CODE]: 'El código postal no es válido.',
  [MercadoPagoCardError.INVALID_STREET_NAME]:
    'El nombre de la calle no es válido.',
  [MercadoPagoCardError.INVALID_REGISTRATION_DATE_FORMAT]:
    'La fecha de registro no tiene un formato válido.',
  [MercadoPagoCardError.INVALID_DESCRIPTION]: 'La descripción no es válida.',
  [MercadoPagoCardError.CARD_REQUIRED]: 'Debes proporcionar la tarjeta.',
  [MercadoPagoCardError.INVALID_CARD]: 'La tarjeta no es válida.',
  [MercadoPagoCardError.INVALID_CARD_DATA]:
    'Los datos de la tarjeta no son válidos.',
  [MercadoPagoCardError.PAYMENT_METHOD_REQUIRED]:
    'Debes indicar el método de pago.',
  [MercadoPagoCardError.ISSUER_ID_REQUIRED]:
    'Debes indicar el identificador del emisor.',
  [MercadoPagoCardError.INVALID_REQUEST_PARAMETERS]:
    'Error al guardar. Revisa la información.',
  [MercadoPagoCardError.CANNOT_UPDATE_CUSTOMER_EMAIL]:
    'No puedes actualizar el email del cliente.',
  [MercadoPagoCardError.MAX_SAVED_CARDS_LIMIT_REACHED]:
    'Has alcanzado el número máximo permitido de tarjetas guardadas.',
  [MercadoPagoCardError.INVALID_CARD_HOLDER]:
    'El titular de la tarjeta no es válido.',
};

export enum MercadoPagoPaymentStatusDetail {
  ACCREDITED = 'accredited',
  PARTIALLY_REFUNDED = 'partially_refunded',
  PENDING_CAPTURE = 'pending_capture',
  OFFLINE_PROCESS = 'offline_process',
  PENDING_CONTINGENCY = 'pending_contingency',
  PENDING_REVIEW_MANUAL = 'pending_review_manual',
  PENDING_WAITING_TRANSFER = 'pending_waiting_transfer',
  PENDING_WAITING_PAYMENT = 'pending_waiting_payment',
  PENDING_CHALLENGE = 'pending_challenge',
  BANK_ERROR = 'bank_error',
  CC_REJECTED_3DS_MANDATORY = 'cc_rejected_3ds_mandatory',
  CC_REJECTED_BAD_FILLED_CARD_NUMBER = 'cc_rejected_bad_filled_card_number',
  CC_REJECTED_BAD_FILLED_DATE = 'cc_rejected_bad_filled_date',
  CC_REJECTED_BAD_FILLED_OTHER = 'cc_rejected_bad_filled_other',
  CC_REJECTED_BAD_FILLED_SECURITY_CODE = 'cc_rejected_bad_filled_security_code',
  CC_REJECTED_BLACKLIST = 'cc_rejected_blacklist',
  CC_REJECTED_CALL_FOR_AUTHORIZE = 'cc_rejected_call_for_authorize',
  CC_REJECTED_CARD_DISABLED = 'cc_rejected_card_disabled',
  CC_REJECTED_DUPLICATED_PAYMENT = 'cc_rejected_duplicated_payment',
  CC_REJECTED_HIGH_RISK = 'cc_rejected_high_risk',
  CC_REJECTED_INSUFFICIENT_AMOUNT = 'cc_rejected_insufficient_amount',
  CC_REJECTED_INVALID_INSTALLMENTS = 'cc_rejected_invalid_installments',
  CC_REJECTED_MAX_ATTEMPTS = 'cc_rejected_max_attempts',
  CC_REJECTED_OTHER_REASON = 'cc_rejected_other_reason',
  CC_REJECTED_TIME_OUT = 'cc_rejected_time_out',
  CC_AMOUNT_RATE_LIMIT_EXCEEDED = 'cc_amount_rate_limit_exceeded',
  REJECTED_HIGH_RISK = 'rejected_high_risk',
  REJECTED_INSUFFICIENT_DATA = 'rejected_insufficient_data',
  REJECTED_BY_BANK = 'rejected_by_bank',
  REJECTED_BY_REGULATIONS = 'rejected_by_regulations',
  REJECTED_BY_BIZ_RULE = 'rejected_by_biz_rule',
}

export const MercadoPagoPaymentMessages: Record<string, string> = {
  [MercadoPagoPaymentStatusDetail.ACCREDITED]: 'Pago acreditado con éxito.',
  [MercadoPagoPaymentStatusDetail.PARTIALLY_REFUNDED]:
    'El pago se realizó, pero se aplicó al menos un reembolso parcial.',
  [MercadoPagoPaymentStatusDetail.PENDING_CAPTURE]:
    'Pago autorizado. A la espera de captura.',
  [MercadoPagoPaymentStatusDetail.OFFLINE_PROCESS]:
    'El pago está siendo procesado de manera offline por falta de procesamiento online.',
  [MercadoPagoPaymentStatusDetail.PENDING_CONTINGENCY]:
    'Falla temporal. El pago será procesado más tarde.',
  [MercadoPagoPaymentStatusDetail.PENDING_REVIEW_MANUAL]:
    'El pago está en revisión manual para determinar su aprobación.',
  [MercadoPagoPaymentStatusDetail.PENDING_WAITING_TRANSFER]:
    'Esperando que completes la transferencia bancaria desde tu banco.',
  [MercadoPagoPaymentStatusDetail.PENDING_WAITING_PAYMENT]:
    'Pago pendiente. Por favor, realiza el pago según las instrucciones.',
  [MercadoPagoPaymentStatusDetail.PENDING_CHALLENGE]:
    'Pago pendiente de confirmación adicional (challenge de seguridad).',
  [MercadoPagoPaymentStatusDetail.BANK_ERROR]:
    'Pago rechazado por error con el banco.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_3DS_MANDATORY]:
    'Pago rechazado: falta completar el challenge 3DS.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_BAD_FILLED_CARD_NUMBER]:
    'Número de tarjeta incorrecto.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_BAD_FILLED_DATE]:
    'Fecha de vencimiento incorrecta.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_BAD_FILLED_OTHER]:
    'Detalles de la tarjeta incorrectos.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_BAD_FILLED_SECURITY_CODE]:
    'Código de seguridad (CVV) incorrecto.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_BLACKLIST]:
    'La tarjeta está inhabilitada por seguridad.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_CALL_FOR_AUTHORIZE]:
    'El banco requiere autorización previa para este pago.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_CARD_DISABLED]:
    'La tarjeta está inactiva.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_DUPLICATED_PAYMENT]:
    'Pago rechazado: transacción duplicada.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_HIGH_RISK]:
    'Pago rechazado por prevención de fraude.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_INSUFFICIENT_AMOUNT]:
    'Saldo o límite de la tarjeta insuficiente.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_INVALID_INSTALLMENTS]:
    'Número de cuotas inválido.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_MAX_ATTEMPTS]:
    'Se superó el número máximo de intentos.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_OTHER_REASON]:
    'Pago rechazado por un error genérico.',
  [MercadoPagoPaymentStatusDetail.CC_REJECTED_TIME_OUT]:
    'Pago rechazado por tiempo excedido.',
  [MercadoPagoPaymentStatusDetail.CC_AMOUNT_RATE_LIMIT_EXCEEDED]:
    'Superaste el límite permitido para este medio de pago.',
  [MercadoPagoPaymentStatusDetail.REJECTED_HIGH_RISK]:
    'Pago rechazado por riesgo o sospecha de fraude.',
  [MercadoPagoPaymentStatusDetail.REJECTED_INSUFFICIENT_DATA]:
    'Falta información obligatoria para procesar el pago.',
  [MercadoPagoPaymentStatusDetail.REJECTED_BY_BANK]:
    'Pago rechazado por el banco.',
  [MercadoPagoPaymentStatusDetail.REJECTED_BY_REGULATIONS]:
    'Pago rechazado por regulaciones.',
  [MercadoPagoPaymentStatusDetail.REJECTED_BY_BIZ_RULE]:
    'Pago rechazado por reglas de negocio.',
};
